export enum ImportStylesModalHeaderEnums {
  IMPORT_LINE_ITEM = 'Import Line Item(s)',
  ORDER_SEARCH_TITLE = 'Order list',
  ORDER_SEARCH_DESC = 'Search for a specific order.',
  IMPORT_LINE_ITEM_DESC = 'Choose where you want to import the line item(s) from:',
  SELECT_STYLE_TITLE = 'Style list',
  SELECT_STYLE_DESC = 'Select the style.',
  SELECT_LINE_ITEMS_DESC = 'Select the line item(s).',

  REPLACE_LINE_ITEM = 'Replace Line item with Import',
  REPLACE_LINE_ITEM_DESC = 'Choose where you want to import the line item from:',
  REPLACE_SELECT_LINE_ITEMS_DESC = 'Select the line item.',
}
